module.exports = __webpack_public_path__ + "static/img/20.df237970.png";